import React from 'react'
import InnerPageBlog from './innerPageBlog'
import TemplateMain from '../templateMain'
import { SLIDESHOWS } from '../../types'

export default function PageBlog() {
  return (
    <TemplateMain
      g_section="more"
      htmlTitle="Blog"
      linksTitle="More..."
      innerPage={<InnerPageBlog />}
      g_sidebarKey="pageBlog"
      g_slideshowKey={SLIDESHOWS.logos}
    />
  )
}
